<template>
    <div class="apprentice-simple-card">
        <div class="internships-overview">
            <div
                class="row"
                v-if="internships.length > 0">
                <div class="col-12 col-md-4 col-xl-3">
                    <div class="internship-filters">
                        <design-2021-internships-filters-component @filter-updated="updateFilter">
                        </design-2021-internships-filters-component>
                    </div>
                </div>
                <div class="col-12 col-md-8 col-xl-9">
                    <div class="internships-overview-grid">
                        <design-2021-internships-student-tools-component :user-credentials-in="userCredentialsIn">
                        </design-2021-internships-student-tools-component>
                        <div class="row">
                            <div
                                class="col-12 col-xl-4 d-flex flex-column"
                                v-for="internship of filteredInternships">
                                <design-2021-internships-student-internship-card-component
                                    :internship-in="internship"
                                    :signed="true"
                                    @show-modal-detail="showModalDetail">
                                    <template #header>
                                        <div class="internship-show-actions">
                                            <b-button
                                                class="btn-file-alt btn-show-internship-agreement remove-icon-margin"
                                                variant="primary-icon"
                                                :v-b-tooltip="$t('internship.view_agreement')"
                                                target="_blank"
                                                @click.prevent.stop="showAgreementFile(internship)">
                                            </b-button>
                                            <b-button
                                                class="btn-upload btn-show-internship-agreement remove-icon-margin"
                                                variant="primary-icon"
                                                :v-b-tooltip="$t('internship.upload_signed_agreement')"
                                                target="_blank"
                                                @click.prevent.stop="showUploadModal(internship)">
                                            </b-button>
                                            <span
                                                class="btn btn-success-icon btn-user-check"
                                                v-if="internship.pivot.accepted"
                                                :v-b-tooltip="$t('internship.registered')">
                                            </span>
                                            <span
                                                class="btn btn-warning-icon btn-hourglass-start"
                                                v-else
                                                :v-b-tooltip="$t('internship.waiting_for_approval')">
                                            </span>

                                            <b-button
                                                class="btn-sign-out btn-internship-sign-out remove-icon-margin"
                                                v-if="internship.pivot.accepted"
                                                variant="danger-icon"
                                                :v-b-tooltip="$t('internship.unsubscribed')"
                                                @click.prevent.stop="signOut(internship.id)">
                                            </b-button>
                                        </div>
                                    </template>
                                </design-2021-internships-student-internship-card-component>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="not-found with-header empty-internship-list"
                v-else>
                <div
                    class="btn-add-circle icon"
                    v-b-tooltip.hover
                    :title="$t('internship.view_all_internships')"
                    @click="showAvailableInternships()"></div>
                <div class="alert-notice">{{ $t('internship.no_registered_internships_found') }}</div>
            </div>
        </div>

        <design-2021-internship-student-motivation-modal-component
            ref="student-motivation-modal"
            :user-credentials-in="this.userCredentialsIn"
            @signUp="signUp($event)"
            @update-signed-in-internships="updateInternship">
        </design-2021-internship-student-motivation-modal-component>

        <design-2021-internship-student-signed-internship-agreement-upload-modal-component
            @upload="upload($event)"
            ref="student-internship-agreement-upload-modal"
            :user-credentials-in="userCredentialsIn">
        </design-2021-internship-student-signed-internship-agreement-upload-modal-component>
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-internships-student-index-component',
    props: {
        internshipsIn: Array,
        userCredentialsIn: Object,
        //educationLevelsIn: Array,
    },
    data() {
        return {
            internships: this.internshipsIn,
            all_internships: [],
            selected: null,
            filters: {
                statusses: [],
            },
            searchTerm: '',
        };
    },
    computed: {
        filteredInternships() {
            if (!this.internships.length) {
                return [];
            }

            let internships = this.internships.filter((internship) => {
                if (this.filters.statusses.length) {
                    let checked = false;

                    statussesLoop: for (const selectedState of this.filters.statusses) {
                        if (internship.pivot.accepted === selectedState) {
                            checked = true;
                            break statussesLoop;
                        }
                    }

                    if (!checked) {
                        return false;
                    }
                }

                return true;
            });

            return internships;
        },
    },

    watch: {
        selected_internships: function (value) {
            this.selected_internships = value;
        },
    },
    methods: {
        signOut(internshipId) {
            this.alert
                .confirm(
                    this.$t('internship.unsubscribe'),
                    this.$t('internship.are_you_sure_you_want_to_unregister_for_this_internship'),
                    this.$t('internship.yes_unregister'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    //call has since been repurposed!
                    this.axios.delete(this.routes.studentInternshipSignout(internshipId)).then(
                        (response) => {
                            this.internships = this.internships.filter((item) => item.id !== internshipId);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        showInternshipDetail(internshipId) {
            const internship = this.internshipsIn.filter((internship) => internship.id === internshipId);
            this.$refs['student-motivation-modal'].show(internshipId, this.hasBeenSignedIn(internship[0]));
        },

        showAgreementFile(internship) {
            window.open(internship.agreement.file.path, '_blank');
        },

        showUploadModal(internship) {
            this.$refs['student-internship-agreement-upload-modal'].show(internship);
        },

        updateFilter(filters) {
            this.filters = { ...filters };
        },

        showModalDetail(internship) {
            this.$refs['student-motivation-modal'].show(internship, true);
        },

        updateInternship(internshipId) {
            this.internships = this.internships.filter((item) => item.id !== internshipId);
        },

        showAvailableInternships() {
            if (this.userCredentialsIn) {
                window.location.href = this.routes.studentInternshipSignup(this.userCredentialsIn.id);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.internship-show-actions {
    display: flex;
    flex-direction: row;
    align-items: center;

    > .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }

        &:before {
            margin-right: 0;
        }
    }
}

.add-internship {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .btn-add-internship {
        flex-direction: column;

        &:before {
            margin-right: 0;
            margin-bottom: map-get($grid-gutter-spacing, 'ten');
        }
    }
}

.empty-internship-list {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
